import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import { SemiConfigFormValues } from '../ProductsConfiguration'
import Species from './Species'
import GRnaCategory from './GRnaCategory'
import CircleLoader from '@src/components/CircleLoader'
import PreDesignedControls from './PreDesignedControls'
import PreDesignedGRna from './PreDesignedGRna'
import StepTitle from '../StepTitle'
import SearchTerms from './SearchTerms'

const SelectClones = () => {
  const formik = useFormikContext<SemiConfigFormValues>()

  return (
    <Grid container>
      <StepTitle
        title={
          <FormattedMessage
            id="CONF_Crispr_Search_Criteria_crisprgrna"
            defaultMessage="Search Criteria"
          />
        }
      />
      <SearchTerms />
      <Species />
      <GRnaCategory />
      <PreDesignedControls />
      <PreDesignedGRna />
      {formik.values?.loading && <CircleLoader />}
    </Grid>
  )
}

export default SelectClones
